<template>
  <div>
    <div v-if="layout === 'vertical'">
      <h6 v-if="label" :class="labelClass">
        {{ label }}
      </h6>

      <input
        :id="id"
        :placeholder="placeholder"
        :type="type"
        @input="onInput"
        @blur="onBlur"
        @focus="onFocus"
        @change="onChange"
        :value="value"
        class="form-control"
        :class="[
          {
            'is-invalid': !isValid,
            'is-valid': isValid && value,
          },
          inputClass,
        ]"
        :disabled="disabled"
      />
    </div>

    <div v-if="layout === 'horizontal'" class="row">
      <h6 v-if="label" class="col-md-2 col-form-label" :class="labelClass">
        {{ label }}
      </h6>

      <div class="col-md-10">
        <input
          :id="id"
          :placeholder="placeholder"
          :type="type"
          @input="onInput"
          @change="onChange"
          @blur="onBlur"
          @focus="onFocus"
          :value="value"
          class="form-control"
          :class="[
            {
              'is-invalid': !isValid,
              'is-valid': isValid && value,
            },
            inputClass,
          ]"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: false,
    },
    layout: {
      type: String,
      required: false,
      default: "vertical",
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    inputClass: {
      type: String,
      required: false,
    },
    labelClass: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: "text",
      required: false,
    },
    value: {
      type: [Number, String],
      required: false,
    },
    isValid: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    onInput(event) {
      // Can add validation here
      this.$emit("input", event.target.value);
    },
    onChange(event) {
      // Supports .lazy
      // Can add validation here
      this.$emit("change", event.target.value);
    },
    onBlur(event) {
      // Can add validation here
      this.$emit("blur", event.target);
    },
    onFocus(event) {
      // Can add validation here
      this.$emit("focus", event.target);
    },
  },
};
</script>

<style></style>
